import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import DataTable from "datatables.net";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { useHistory } from "react-router";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import alertify from "alertifyjs";
import { date_format, datetime_format } from "../Common/DateFormat";
import { API_URL, BACKEND_URL } from "../constants.js";
import {
  printReportUrl,
  reportEditUrl,
} from "../Common/patientIdentifier";
import PrintIcon from "@material-ui/icons/Print";
import DescriptionIcon from "@material-ui/icons/Description";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import EmailIcon from "@material-ui/icons/Email";
import LinkIcon from "@material-ui/icons/Link";
import FlagIcon from "@material-ui/icons/Flag";
import InsertCommentIcon from "@material-ui/icons/InsertComment";
import StarIcon from "@material-ui/icons/Star";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import NoteAddIcon from "@material-ui/icons/NoteAdd";
import CommentIcon from "@material-ui/icons/Comment";
import ArchiveIcon from "@material-ui/icons/Archive";
import CancelTwoToneIcon from "@material-ui/icons/CancelTwoTone";
import EditIcon from "@material-ui/icons/Edit";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { submitLabResult } from "../services/docusApi";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";

export function PatientsWithReport(props) {
  const { t } = useTranslation();
  const [patients, setPatients] = useState([]);
  const [patient, setPatient] = useState(null);
  const [singlePatient, setSinglePatient] = useState(null);
  const [show, setShow] = useState(false);
  const [additionalRemarksModal, setAdditionalRemarksModal] = useState(false);
  const [internalNotesModal, setInternalNotesModal] = useState(false);
  const [blueRemarksModal, setBlueRemarksModal] = useState(false);
  const [passwordVerified, setPasswordVerified] = useState(false);
  const [action, setAction] = useState("patient");
  const history = useHistory();
  const [disabled, setDisabled] = useState(0);
  const [checkedItems, setCheckedItems] = useState({});
  const [blueRemarksList, setBlueRemarksList] = useState([]);
  const [selectedBlueRemarks, setSelectedBlueRemarks] = useState([]);
  const additional_remarks = useRef();
  const internal_notes = useRef();
  const blue_remarks = useRef();

  const password = useRef();

  const handleDocusSubmit = async (patient) => {
    setDisabled(1);
    try {
      const res = await submitLabResult(patient.sample_id);
      if (res.success) {
        alertify.success("Lab results submitted to Docus successfully");
        setPatients((patients) =>
          patients.map((p) =>
            p.id === patient.id
              ? { ...p, has_docus_result_submitted: true }
              : p
          )
        );
      } else {
        alertify.error("Error: " + JSON.stringify(res.error));
      }
    } catch (err) {
      alertify.error("Network error: " + err.message);
    } finally {
      setDisabled(0);
    }
  };

  const handleDocusDownload = (patient) => {
    if (!patient.docus_received_at || !patient.docus_patient_access_url) return;
    window.open(patient.docus_patient_access_url, "_blank");
  };

  const setCurrentPatient = (patient_id, action) => {
    setPatient(patient_id);

    if (action == "mail") {
      sendSingleEmail(patient_id);
      /*if (passwordVerified) {
                sendSingleEmail();
            } else {
                setShow(true);
            }*/
    } else if (action == "docus_access_link") {
      sendDocusAccessLink(patient_id);
    } else if (
      action == "has_flagged" ||
      action == "has_haemolusis" ||
      action == "has_trustpilot"
    ) {
      sendQuickAction(patient_id, action);
    } else if (action == "additional_remarks") {
      setPatient(patient_id);
      const currentPatient = patients.find((p) => p.id === patient_id);
      setSinglePatient(currentPatient);
      setAdditionalRemarksModal(true);
    } else if (action == "internal_notes") {
      setPatient(patient_id);
      const currentPatient = patients.find((p) => p.id === patient_id);
      setSinglePatient(currentPatient);
      setInternalNotesModal(true);
    } else if (action == "blue_remarks") {
      setPatient(patient_id);
      const currentPatient = patients.find((p) => p.id === patient_id);
      setSinglePatient(currentPatient);
      // Set selected remarks from patient data (array of IDs)
      if (currentPatient?.blue_remarks && Array.isArray(currentPatient.blue_remarks)) {
        setSelectedBlueRemarks(currentPatient.blue_remarks);
      } else if (currentPatient?.blue_remarks) {
        // Handle if it's stored as JSON string
        try {
          const parsed = JSON.parse(currentPatient.blue_remarks);
          setSelectedBlueRemarks(Array.isArray(parsed) ? parsed : []);
        } catch {
          setSelectedBlueRemarks([]);
        }
      } else {
        setSelectedBlueRemarks([]);
      }
      setBlueRemarksModal(true);
    } else if (action == "archive_registration") {
      archivePatient(patient_id);
    } else if (action == "reject_sample") {
      rejectSample(patient_id);
    }
  };

  const archivePatient = (id) => {
    console.log("id", id, patients);
    setDisabled(1);
    axios.post(API_URL + `patient/${id}/archive`).then((response) => {
      setDisabled(0);
      console.log("response", response);
      if (response.data.status == true) {
        setPatients(
          patients.filter((val) => {
            return val.id != id;
          })
        );
        console.log(patients);
        alertify.success(response.data.message);
      } else {
        alertify.error(response.data.message);
        return null;
      }
    });
  };
  const rejectSample = (id) => {
    console.log("id", id, patients);
    setDisabled(1);
    axios.post(API_URL + `patient/${id}/sample-rejected`).then((response) => {
      setDisabled(0);
      console.log("response", response);
      if (response.data.status == true) {
        setPatients(
          patients.filter((val) => {
            return val.id != id;
          })
        );
        console.log(patients);
        alertify.success(response.data.message);
      } else {
        alertify.error(response.data.message);
        return null;
      }
    });
  };
  const handleClose = () => {
    setShow(false);
    setAdditionalRemarksModal(false);
    setInternalNotesModal(false);
    setBlueRemarksModal(false);
    setSelectedBlueRemarks([]);
  };

  const deletePatient = () => {
    axios
      .post(API_URL + "patient/delete", {
        id: patient,
        action: action,
      })
      .then((response) => {
        if (response.data.status) {
          history.go(0);
          setShow(false);
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  useEffect(() => {
    // getPatientsWithReport();
    if (!passwordVerified) {
      setShow(true);
    }
    // Fetch blue remarks list
    getBlueRemarksList();
  }, []);

  const getBlueRemarksList = () => {
    axios
      .get(API_URL + "blue-remarks?active_only=1")
      .then((response) => {
        if (response.data.status) {
          setBlueRemarksList(response.data.data);
        } else {
          alertify.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching blue remarks:", error);
      });
  };

  const getPatientsWithReport = () => {
    axios
      .get(API_URL + "patients-with-report")
      .then((response) => {
        if (response.data.status) {
          setPatients(response.data.data);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      })
      .catch((error) => {
        if (error.message === "Request failed with status code 401") {
          //props.logout();
        }
      });
  };

  useEffect(() => {
    if (!patients.length || $.fn.DataTable.isDataTable("#patient_table")) {
      return;
    }
    $("#patient_table").DataTable();
  }, [patients]);

  const handleCheckboxChange = (event, id) => {
    setCheckedItems({
      ...checkedItems,
      [id]: event.target.checked,
    });
  };

  useEffect(() => {
    console.log("items: ", checkedItems);
  }, [checkedItems]);

  const sendBulkEmail = () => {
    setDisabled(1);
    axios
      .post(API_URL + "patient/send-mail", { patients: checkedItems })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  const sendQuickAction = (patient_id, action) => {
    setDisabled(1);
    axios
      .post(API_URL + "patient/send-quick-action", {
        id: patient_id,
        action: action,
      })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          setPatients((patients) =>
            patients.map((p) =>
              p.id === patient_id ? { ...p, [action]: !p[action] } : p
            )
          );
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };
  const sendSingleEmail = (patient_id) => {
    setDisabled(1);
    axios
      .post(API_URL + "patient/send-mail", { id: patient_id })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  const sendDocusAccessLink = (patient_id) => {
    setDisabled(1);
    axios
      .post(API_URL + "patient/send-docus-access-link", { id: patient_id })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          alertify.success(
            response.data.message ||
              "Docus access link email sent successfully."
          );
        } else {
          alertify.error(
            response.data.message ||
              "Failed to send Docus access link email."
          );
          return null;
        }
      })
      .catch((error) => {
        setDisabled(0);
        alertify.error(
          error.response?.data?.message ||
            error.message ||
            "Failed to send Docus access link"
        );
      });
  };

  const toggleSelectAllPatients = (event) => {
    let selected_patients = {};
    for (let p in patients) {
      selected_patients[patients[p].id] = event.target.checked;
    }

    setCheckedItems(selected_patients);
  };

  const verifyPassword = (e) => {
    e.preventDefault();
    setDisabled(1);

    axios
      .post(API_URL + "user/verify-password", {
        password: password.current.value,
      })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          setShow(false);
          setPasswordVerified(true);
          getPatientsWithReport();
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  const addAdditionalRemarks = (e) => {
    e.preventDefault();
    setDisabled(1);
    axios
      .post(API_URL + "patient/add-additional-remarks", {
        id: patient,
        additional_remarks: additional_remarks.current.value,
      })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          setAdditionalRemarksModal(false);
          setPatients((patients) =>
            patients.map((p) =>
              p.id === patient
                ? { ...p, additional_remarks: additional_remarks.current.value }
                : p
            )
          );
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };
  const addInternalNotes = (e) => {
    e.preventDefault();
    console.log("internal_notes");
    setDisabled(1);
    axios
      .post(API_URL + "patient/add-internal-notes", {
        id: patient,
        internal_notes: internal_notes.current.value,
      })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          setInternalNotesModal(false);
          setPatients((patients) =>
            patients.map((p) =>
              p.id === patient
                ? { ...p, internal_notes: internal_notes.current.value }
                : p
            )
          );
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };
  const handleBlueRemarkChange = (remarkId) => {
    setSelectedBlueRemarks((prev) => {
      if (prev.includes(remarkId)) {
        return prev.filter((id) => id !== remarkId);
      } else {
        return [...prev, remarkId];
      }
    });
  };

  const addBlueRemarks = (e) => {
    e.preventDefault();
    setDisabled(1);
    axios
      .post(API_URL + "patient/add-blue-remarks", {
        id: patient,
        blue_remarks: selectedBlueRemarks,
      })
      .then((response) => {
        setDisabled(0);
        if (response.data.status) {
          setBlueRemarksModal(false);
          setPatients((patients) =>
            patients.map((p) =>
              p.id === patient
                ? { ...p, blue_remarks: selectedBlueRemarks }
                : p
            )
          );
          alertify.success(response.data.message);
        } else {
          alertify.error(response.data.message);
          return null;
        }
      });
  };

  return (
    <>
      <style>{`.patient-actions .btn:hover svg { color: currentColor !important; }`}</style>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader title={t("Reports To Send Email")}>
              <CardHeaderToolbar>
                <Button
                  as={Link}
                  to="/patient/archive-samples"
                  variant="info"
                  className="mr-3"
                >
                  Archive Sample
                </Button>
                <Button
                  variant="primary"
                  onClick={sendBulkEmail}
                  disabled={disabled}
                >
                  Send
                  <span
                    dangerouslySetInnerHTML={{
                      __html: disabled
                        ? `<i class='fas fa-spinner fa-spin'></i>`
                        : ``,
                    }}
                  />
                </Button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody style={{ overflow: "auto" }}>
              <table
                id="patient_table"
                className="stratprop_datatable table table-striped table-bordered"
              >
                <thead>
                  <tr key={"thead"}>
                    <th>
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          toggleSelectAllPatients(e);
                        }}
                      />
                    </th>
                    <th>{t("SN.")}</th>
                    <th style={{ width: "100px" }}>{t("Actions")}</th>
                    <th>{t("Sample ID")}</th>
                    <th>{t("Name")}</th>
                    <th style={{ width: "250px" }}>{t("Test Type")}</th>
                    {/*<th>{t("Result")}</th>*/}
                    <th>{t("Registered at")}</th>
                    <th>{t("Gender / DOB")}</th>
                    <th>{t("Collection Date Time")}</th>
                  </tr>
                </thead>
                <tbody>
                  {patients.length > 0 ? (
                    patients.map((patient, index) => (
                      <tr key={patient.id} className={patient.sent_activation_msg == 1 ? 'sent-activation-msg' : ''}>
                        <td>
                          <Form.Check
                            key={patient.id}
                            type={"checkbox"}
                            id={`checkbox-${index}`}
                            checked={checkedItems[patient.id] || false}
                            onChange={(e) => {
                              handleCheckboxChange(e, patient.id);
                            }}
                            value={""}
                          />
                        </td>
                        <td>{index + 1}</td>
                        <td>
                          <div className="d-flex flex-wrap patient-actions" style={{ width: "100px" }}>
                          <a
                            disabled={disabled}
                            title={"Send Email"}
                            onClick={() =>
                              setCurrentPatient(patient.id, "mail")
                            }
                            className="btn btn-outline-secondary m-1"
                            style={{ width: "42px" }}
                          >
                            <EmailIcon color="inherit"></EmailIcon>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: disabled
                                  ? `<i class='fas fa-spinner fa-spin'></i>`
                                  : ``,
                              }}
                            />
                          </a>
                          <a
                            href={printReportUrl(patient.sample_id)}
                            target={"_blank"}
                            className="btn btn-outline-primary m-1"
                            style={{ width: "42px" }}
                            title={"Print Report"}
                          >
                            <DescriptionIcon color="inherit"></DescriptionIcon>
                          </a>
                          <Link
                            to={reportEditUrl(patient.sample_id)}
                            className="btn btn-outline-primary m-1"
                            style={{ width: "42px" }}
                            title={"Edit Report"}
                          >
                            <EditIcon color="inherit"></EditIcon>
                          </Link>
                          {patient.has_flagged ? (
                            <a
                              disabled={disabled}
                              title={"Flag"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "has_flagged")
                              }
                              className="btn btn-danger m-1"
                              style={{ width: "42px" }}
                            >
                              <FlagIcon color="inherit"></FlagIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          ) : (
                            <a
                              disabled={disabled}
                              title={"Flag"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "has_flagged")
                              }
                              className="btn btn-outline-danger m-1"
                              style={{ width: "42px" }}
                            >
                              <FlagIcon color="inherit"></FlagIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          )}

                          {patient.has_haemolusis ? (
                            <a
                              disabled={disabled}
                              title={"Haemolusis"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "has_haemolusis")
                              }
                              className="btn btn-warning m-1"
                              style={{ width: "42px" }}
                            >
                              <InsertCommentIcon color="inherit"></InsertCommentIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          ) : (
                            <a
                              disabled={disabled}
                              title={"Haemolusis"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "has_haemolusis")
                              }
                              className="btn btn-outline-warning m-1"
                              style={{ width: "42px" }}
                            >
                              <InsertCommentIcon color="inherit"></InsertCommentIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          )}

                          {patient.has_trustpilot ? (
                            <a
                              disabled={disabled}
                              title={"Trustpilot"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "has_trustpilot")
                              }
                              className="btn btn-success m-1"
                              style={{ width: "42px" }}
                            >
                              <StarIcon color="inherit"></StarIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          ) : (
                            <a
                              disabled={disabled}
                              title={"Trustpilot"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "has_trustpilot")
                              }
                              className="btn btn-outline-success m-1"
                              style={{ width: "42px" }}
                            >
                              <StarIcon color="inherit"></StarIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          )}
                          <a
                            disabled={disabled}
                            title={"Archive Registration"}
                            onClick={() =>
                              setCurrentPatient(
                                patient.id,
                                "archive_registration"
                              )
                            }
                            className="btn btn-outline-secondary m-1"
                            style={{ width: "42px" }}
                          >
                            <ArchiveIcon color="inherit"></ArchiveIcon>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: disabled
                                  ? `<i class='fas fa-spinner fa-spin'></i>`
                                  : ``,
                              }}
                            />
                          </a>
                          {/* reject */}
                          <a
                            disabled={disabled}
                            title={"Reject Sample"}
                            onClick={() =>
                              setCurrentPatient(patient.id, "reject_sample")
                            }
                            className="btn btn-outline-danger m-1"
                            style={{ width: "42px" }}
                          >
                            <CancelTwoToneIcon color="inherit"></CancelTwoToneIcon>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: disabled
                                  ? `<i class='fas fa-spinner fa-spin'></i>`
                                  : ``,
                              }}
                            />
                          </a>

                          {patient?.internal_notes?.length > 0 ? (
                            <a
                              disabled={disabled}
                              title={"Internal Notes"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "internal_notes")
                              }
                              className="btn btn-primary m-1"
                              style={{ width: "42px" }}
                            >
                              <NoteAddIcon color="inherit"></NoteAddIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          ) : (
                            <a
                              disabled={disabled}
                              title={"Internal Notes"}
                              onClick={() =>
                                setCurrentPatient(patient.id, "internal_notes")
                              }
                              className="btn btn-outline-primary m-1"
                              style={{ width: "42px" }}
                            >
                              <NoteAddIcon color="inherit"></NoteAddIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          )}
                          {/* additional remarks */}
                          {patient?.additional_remarks?.length > 0 ? (
                            <a
                              disabled={disabled}
                              title={"Additional Remarks"}
                              onClick={() =>
                                setCurrentPatient(
                                  patient.id,
                                  "additional_remarks"
                                )
                              }
                              className="btn btn-primary m-1"
                              style={{ width: "42px" }}
                            >
                              <MoreHorizIcon color="inherit"></MoreHorizIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          ) : (
                            <a
                              disabled={disabled}
                              title={"Additional Remarks"}
                              onClick={() =>
                                setCurrentPatient(
                                  patient.id,
                                  "additional_remarks"
                                )
                              }
                              className="btn btn-outline-primary m-1"
                              style={{ width: "42px" }}
                            >
                              <MoreHorizIcon color="inherit"></MoreHorizIcon>
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: disabled
                                    ? `<i class='fas fa-spinner fa-spin'></i>`
                                    : ``,
                                }}
                              />
                            </a>
                          )}
                          {/* blue remarks */}
                          {(() => {
                            const hasBlueRemarks = 
                              (Array.isArray(patient?.blue_remarks) && patient.blue_remarks.length > 0) ||
                              (typeof patient?.blue_remarks === 'string' && patient.blue_remarks.length > 0);
                            
                            return hasBlueRemarks ? (
                              <a
                                disabled={disabled}
                                title={"Blue Remark"}
                                onClick={() =>
                                  setCurrentPatient(patient.id, "blue_remarks")
                                }
                                className="btn btn-info m-1"
                                style={{ width: "42px" }}
                              >
                                <CommentIcon color="inherit"></CommentIcon>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: disabled
                                      ? `<i class='fas fa-spinner fa-spin'></i>`
                                      : ``,
                                  }}
                                />
                              </a>
                            ) : (
                              <a
                                disabled={disabled}
                                title={"Blue Remark"}
                                onClick={() =>
                                  setCurrentPatient(patient.id, "blue_remarks")
                                }
                                className="btn btn-outline-info m-1"
                                style={{ width: "42px" }}
                              >
                                <CommentIcon color="inherit"></CommentIcon>
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: disabled
                                      ? `<i class='fas fa-spinner fa-spin'></i>`
                                      : ``,
                                  }}
                                />
                              </a>
                            );
                          })()}
                          <a
                            onClick={() => {
                              if (!patient.has_docus_result_submitted)
                                handleDocusSubmit(patient);
                            }}
                            className={`btn btn-outline-info m-1 ${
                              patient.has_docus_result_submitted ? "disabled" : ""
                            }`}
                            style={{
                              width: "42px",
                              pointerEvents: patient.has_docus_result_submitted
                                ? "none"
                                : "auto",
                            }}
                            aria-disabled={
                              patient.has_docus_result_submitted ? "true" : "false"
                            }
                            title={
                              patient.has_docus_result_submitted
                                ? "Docus: Lab Results Already Submitted"
                                : "Docus: Submit Lab Results"
                            }
                          >
                            <CloudUploadIcon color="inherit"></CloudUploadIcon>
                          </a>
                          <a
                            onClick={() => handleDocusDownload(patient)}
                            className={`btn btn-outline-success m-1 ${
                              patient.docus_received_at ? "" : "disabled"
                            }`}
                            style={{
                              width: "42px",
                              pointerEvents: patient.docus_received_at
                                ? "auto"
                                : "none",
                            }}
                            aria-disabled={
                              patient.docus_received_at ? "false" : "true"
                            }
                            title={
                              patient.docus_received_at
                                ? "Docus: Download Report"
                                : "Docus: Report not received yet"
                            }
                          >
                            <CloudDownloadIcon color="inherit"></CloudDownloadIcon>
                          </a>
                          <a
                            disabled={disabled}
                            title={"Send Docus Link"}
                            onClick={() =>
                              setCurrentPatient(patient.id, "docus_access_link")
                            }
                            className="btn btn-outline-info m-1"
                            style={{ width: "42px" }}
                          >
                            <LinkIcon color="inherit"></LinkIcon>
                            <span
                              dangerouslySetInnerHTML={{
                                __html: disabled
                                  ? `<i class='fas fa-spinner fa-spin'></i>`
                                  : ``,
                              }}
                            />
                          </a>
                          </div>
                        </td>
                        <td>
                          {patient.sample_id}
                          <br />
                          <span className={`badge badge-primary`}>
                            {patient.report_status.name}
                          </span>
                        </td>
                        <td>
                          <span className={`badge badge-light patient-badge`}>
                            {patient.patient_master?.unique_patient_no}
                          </span>
                          <br />
                          <span className={"font-bold"}>
                            {patient.first_name}
                          </span>
                          <br />
                          <span>{patient.last_name}</span>
                          <br />
                          <a
                            className={`font-bold`}
                            href={`mailto:${patient.email}`}
                          >
                            {patient.email}
                          </a>
                        </td>
                        {/*<td>
                        <ul>
                          {patient.patient_tests.length > 0 ? (
                            patient.patient_tests.map((patient_test, index) => (
                              <li>{patient_test.test?.name}</li>
                            ))
                          ) : ''
                          }
                        </ul>
                      </td>*/}
                        <td>
                          {patient.result_data.length > 0
                            ? patient.result_data.map((test, index) => (
                                <>
                                  <strong>{test.name}</strong>
                                  {test.details.length > 0 ? (
                                    <ul>
                                      {test.details.map((detail, index) => (
                                        <li
                                          className={`result-` + detail.color}
                                        >
                                          {detail.name}: {detail.result}
                                        </li>
                                      ))}
                                    </ul>
                                  ) : (
                                    <br />
                                  )}
                                </>
                              ))
                            : ""}
                        </td>

                        <td>
                          {patient.registered_at
                            ? datetime_format(patient.registered_at)
                            : ""}
                        </td>
                        {/*<td>{(patient.collection_datetime) ? datetime_format(patient.collection_datetime) : ""}</td>*/}
                        <td>
                          <span className={`font-bold`}>{patient.gender}</span>
                          <br />
                          <span>{date_format(patient.dob)}</span>
                          {patient.menstrual_cycle_relation ? (
                            <>
                              <br />
                              <span
                                className="font-bold"
                                style={{
                                  display: "inline-block",
                                  marginTop: "4px",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  backgroundColor: "#f3a6ad",
                                  color: "#721c24",
                                }}
                              >
                                {patient.menstrual_cycle_relation ===
                                  "days_since_last_period" &&
                                patient.menstrual_cycle_day !== null &&
                                patient.menstrual_cycle_day !== undefined &&
                                patient.menstrual_cycle_day !== ""
                                  ? `${patient.menstrual_cycle_day} `
                                  : ""}
                                {patient.menstrual_cycle_relation
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (letter) =>
                                    letter.toUpperCase()
                                  )}
                              </span>
                            </>
                          ) : null}
                        </td>
                        {/*<td>{patient.phone_no}</td>*/}
                        <td>
                          {patient.collection_datetime
                            ? datetime_format(patient.collection_datetime)
                            : ""}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr key={"nopatient"}>
                      <td colSpan={13}>No Patient</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal show={show} onHide={handleClose}>
        <Form onSubmit={verifyPassword}>
          <Modal.Header closeButton>
            <Modal.Title>{t("Password Verification")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={"mt-5"}>
              <Row className={"mb-10 "}>
                <Form.Group as={Col}>
                  <Form.Label>{t("Enter Password")}</Form.Label>
                  <Form.Control
                    type={"password"}
                    ref={password}
                    placeholder={t("password")}
                  />
                </Form.Group>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Close")}
            </Button>
            <Button variant="primary" disabled={disabled} type="submit">
              Verify
              <span
                dangerouslySetInnerHTML={{
                  __html: disabled
                    ? `<i class='fas fa-spinner fa-spin'></i>`
                    : ``,
                }}
              />
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* modal for additional remarks */}
      <Modal show={additionalRemarksModal} onHide={handleClose}>
        <Form onSubmit={addAdditionalRemarks}>
          <Modal.Header closeButton>
            <Modal.Title>{t("Additional Remarks")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={"mt-5"}>
              <Row className={"mb-10 "}>
                <Form.Group as={Col}>
                  <Form.Label>{t("Enter Remarks")}</Form.Label>
                  <Form.Control
                    as={"textarea"}
                    defaultValue={singlePatient?.additional_remarks || ""}
                    ref={additional_remarks}
                    placeholder={t("Additional Remarks")}
                  />
                </Form.Group>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Close")}
            </Button>
            <Button variant="primary" disabled={disabled} type="submit">
              Save
              <span
                dangerouslySetInnerHTML={{
                  __html: disabled
                    ? `<i class='fas fa-spinner fa-spin'></i>`
                    : ``,
                }}
              />
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* modal for internal notes */}
      <Modal show={internalNotesModal} onHide={handleClose}>
        <Form onSubmit={addInternalNotes}>
          <Modal.Header closeButton>
            <Modal.Title>{t("Internal Notes")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={"mt-5"}>
              <Row className={"mb-10 "}>
                <Form.Group as={Col}>
                  <Form.Label>{t("Enter Notes")}</Form.Label>
                  <Form.Control
                    as={"textarea"}
                    defaultValue={singlePatient?.internal_notes || ""}
                    ref={internal_notes}
                    placeholder={t("Internal Notes")}
                  />
                </Form.Group>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Close")}
            </Button>
            <Button variant="primary" disabled={disabled} type="submit">
              Save
              <span
                dangerouslySetInnerHTML={{
                  __html: disabled
                    ? `<i class='fas fa-spinner fa-spin'></i>`
                    : ``,
                }}
              />
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* modal for blue remarks */}
      <Modal show={blueRemarksModal} onHide={handleClose} size="lg">
        <Form onSubmit={addBlueRemarks}>
          <Modal.Header closeButton>
            <Modal.Title>{t("Blue Remarks")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={"mt-5"}>
              <Row className={"mb-10 "}>
                <Form.Group as={Col}>
                  <Form.Label>{t("Select Blue Remarks")}</Form.Label>
                  <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #ddd", padding: "10px", borderRadius: "4px" }}>
                    {blueRemarksList.length > 0 ? (
                      blueRemarksList.map((remark) => (
                        <Form.Check
                          key={remark.id}
                          type="checkbox"
                          id={`blue-remark-${remark.id}`}
                          label={remark.name || remark.remark || remark.title}
                          checked={selectedBlueRemarks.includes(remark.id)}
                          onChange={() => handleBlueRemarkChange(remark.id)}
                          className="mb-2"
                        />
                      ))
                    ) : (
                      <p className="text-muted">{t("No blue remarks available")}</p>
                    )}
                  </div>
                  {selectedBlueRemarks.length > 0 && (
                    <small className="text-muted mt-2 d-block">
                      {t("Selected")}: {selectedBlueRemarks.length} {t("remark(s)")}
                    </small>
                  )}
                </Form.Group>
              </Row>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t("Close")}
            </Button>
            <Button variant="primary" disabled={disabled} type="submit">
              Save
              <span
                dangerouslySetInnerHTML={{
                  __html: disabled
                    ? `<i class='fas fa-spinner fa-spin'></i>`
                    : ``,
                }}
              />
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
